export const exportTableToCSV = (tableIdentifier, filename = 'export.csv') => {
  const table = document.querySelector(tableIdentifier)

  if (table) {
    const stringifiedCSVData = tableToCSVData(table)
    const csvFile = new Blob([stringifiedCSVData], { type: 'text/csv' })

    let downloadLink = document.createElement('a')
    downloadLink.download = filename
    downloadLink.href = window.URL.createObjectURL(csvFile)
    downloadLink.style.display = 'none'
    document.body.appendChild(downloadLink)

    downloadLink.click()

    document.body.removeChild(downloadLink)
  }
}

const tableToCSVData = (table) => {
  let csvData = []
  const rows = table.querySelectorAll('tr')

  rows.forEach((row) => {
    let rowData = []
    const cols = row.querySelectorAll('td, th')

    cols.forEach((col) => {
      // This lets you specify a different element to export as text for the CSV.
      // For example, you may want to export a link but show a download icon in the UI instead.
      // Elements with this class should add the `display-none` class in the UI.
      //
      // Keep in mind that this is optional and only needed if you want to override the default
      // of exporting the text content of the cell.
      let textContainer = col.querySelector('.csv-export-text') || col

      rowData.push('"' + textContainer.innerText + '"')
    })

    csvData.push(rowData.join(','))
  })

  return csvData.join('\n')
}

window.exportTableToCSV = exportTableToCSV
